export default __webpack_public_path__ + "3c1fcf7c0a198d6e5e2d94ae2782a6ce.svg";